export interface PublicHeaderLink {
	labelKey: string;
	defaultLabel: string;
	path: string;
}

export const LANDING_LOCALIZED_PATHS: Record<
	string,
	{ en: string; pl: string }
> = {
	'/': { en: '/', pl: '/' },
	'/buyer': { en: '/buyer', pl: '/kupujacy' },
	'/producer': { en: '/producer', pl: '/sprzedawca' },
	'/carrier': { en: '/carrier', pl: '/transport' },
	'/about-us': { en: '/about-us', pl: '/o-nas' },
	'/contact-us': { en: '/contact-us', pl: '/kontakt-z-nami' },
	'/blog': { en: '/blog', pl: '/blog' },
	'/faq-customers': { en: '/faq-customers', pl: '/faq-kupujacy' },
	'/faq-producers': { en: '/faq-producers', pl: '/faq-sprzedawcy' },
	'/faq-transporters': { en: '/faq-transporters', pl: '/faq-transport' },
	'/register': { en: '/register', pl: '/rejestracja' },
	'/login': { en: '/login', pl: '/logowanie' },
};

export const PUBLIC_HEADER_LINKS: PublicHeaderLink[] = [
	{ labelKey: 'publicHeader.buy', defaultLabel: 'Buy', path: '/buyer' },
	{ labelKey: 'publicHeader.sell', defaultLabel: 'Sell', path: '/producer' },
	{
		labelKey: 'publicHeader.transport',
		defaultLabel: 'Transport',
		path: '/carrier',
	},
	{
		labelKey: 'publicHeader.aboutUs',
		defaultLabel: 'About us',
		path: '/about-us',
	},
];

export const PUBLIC_HEADER_MORE_LINKS: PublicHeaderLink[] = [
	{
		labelKey: 'publicHeader.contactUs',
		defaultLabel: 'Contact us',
		path: '/contact-us',
	},
	{ labelKey: 'publicHeader.blog', defaultLabel: 'Blog', path: '/blog' },
	{
		labelKey: 'publicHeader.faqBuyers',
		defaultLabel: 'FAQ for Buyers',
		path: '/faq-customers',
	},
	{
		labelKey: 'publicHeader.faqSellers',
		defaultLabel: 'FAQ for Sellers',
		path: '/faq-producers',
	},
	{
		labelKey: 'publicHeader.faqCarriers',
		defaultLabel: 'FAQ for Carriers',
		path: '/faq-transporters',
	},
];

export const PUBLIC_HEADER_MOBILE_LINKS: PublicHeaderLink[] = [
	{
		labelKey: 'publicHeader.buyMaterials',
		defaultLabel: 'Buy construction materials',
		path: '/buyer',
	},
	{
		labelKey: 'publicHeader.sellMaterials',
		defaultLabel: 'Sell construction materials',
		path: '/producer',
	},
	{
		labelKey: 'publicHeader.transportMaterials',
		defaultLabel: 'Transport construction materials',
		path: '/carrier',
	},
	{
		labelKey: 'publicHeader.aboutUs',
		defaultLabel: 'About us',
		path: '/about-us',
	},
	{
		labelKey: 'publicHeader.contactUs',
		defaultLabel: 'Contact us',
		path: '/contact-us',
	},
];

export interface PublicLanguage {
	code: 'en' | 'pl';
	flag: string;
	labelKey: string;
	defaultLabel: string;
}

export const PUBLIC_LANGUAGES: PublicLanguage[] = [
	{
		code: 'en',
		flag: 'GBR',
		labelKey: 'languagePicker.english',
		defaultLabel: 'English',
	},
	{
		code: 'pl',
		flag: 'POL',
		labelKey: 'languagePicker.polish',
		defaultLabel: 'Polish',
	},
];
